import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"

export interface SmsVerificationState {
  phone: string | null
  verified: boolean
  verified_phone: string | null
  verified_at: string | null
  stopped: boolean
  stopped_at: string | null
  last_failure: { at: string; reason: string } | null
  available: boolean
  start_number?: string | null
}

export interface SmsCodeSent extends SmsVerificationState {
  expires_in: number
  resend_in: number
}

interface Envelope<T> {
  status: string
  details: { message: string; data: T }
}

export interface SmsRefusal {
  code?: string
  message?: string
  retry_after?: number
  attempts_left?: number
}

const BASE = "/notifications/sms/verification/"

export const getSmsVerification = (): Promise<
  ApiResponse<SmsVerificationState>
> => request.api.get(BASE)

export const sendSmsCode = (
  phone: string
): Promise<ApiResponse<Envelope<SmsCodeSent>>> =>
  request.api.post(`${BASE}send-code/`, { phone })

export const verifySmsCode = (
  phone: string,
  code: string
): Promise<ApiResponse<Envelope<SmsVerificationState>>> =>
  request.api.post(`${BASE}verify/`, { phone, code })

export const refusalOf = (response: ApiResponse<unknown>): SmsRefusal => {
  const data = response.data as
    | { details?: SmsRefusal; message?: { detail?: string } }
    | undefined
  return {
    ...data?.details,
    message: data?.details?.message ?? data?.message?.detail
  }
}
